import React from 'react';
import { Menu, Header, Card, Button, Loader } from 'semantic-ui-react';
import { Link } from 'react-router-dom';

import MediaActions from './MediaActions';
import PlaceholderCards from './PlaceholderCards';

const EpisodeFeed = ({ header, loading, episodes, filter }) => (
  <>
    <Menu secondary>
      <Menu.Item>
        <Header as="h2" content={header} />
      </Menu.Item>
      <Menu.Item>
        {filter && (
          <Button basic as={Link} to="/" icon="chevron left" content="Back" />
        )}
      </Menu.Item>
    </Menu>

    <Card.Group centered>
      {episodes.length > 0 && !loading ? (
        filterEpisodes(episodes, filter).map((episode, i) => (
          <Card
            className="episode"
            key={`${episode.name}${i}`}
            meta={<Meta episode={episode} />}
            header={episode.name}
            description={episode.summary}
            extra={
              <MediaActions
                types={episode.types}
                id={episode.id}
                externalLink={episode.types.link ? episode.externalLink : ''}
              />
            }
          />
        ))
      ) : (
        <>
          <PlaceholderCards />
          <Loader active />
        </>
      )}
    </Card.Group>
  </>
);

const filterEpisodes = (episodes, filter) =>
  filter
    ? episodes.filter((episode) =>
        episode.categories ? episode.categories[filter] : false
      )
    : episodes;

const Meta = ({ episode }) => (
  <a className="link" href={episode.ministryLink}>
    {episode.ministryName}
  </a>
);

export default EpisodeFeed;
